// AutoCoach24 — Geschäftsdaten & Konstanten
export const COMPANY = {
  name: "AutoCoach",
  legalName: "AutoCoach",
  tagline: "Beratung. Verkauf. Erfolg.",
  street: "Herrhausenstraße 11",
  zip: "27721",
  city: "Ritterhude",
  email: "info@auto-coach24.de",
  phoneDisplay: "0172 1375333",
  phoneIntl: "+49 172 1375333",
  whatsappNumber: "491721375333", // wa.me format
  instagram: "https://www.instagram.com/autocoach_",
  instagramHandle: "@autocoach_",
  logo:
    "https://customer-assets.emergentagent.com/job_auto-coach-rebuild/artifacts/bn1ofv5o_WhatsApp_Image_2026-05-25_at_01.11.34-removebg-preview%20%281%29.png",
};

// Live Spar-Ticker — anonymisierte Beispiele
export const SAVINGS_FEED = [
  { name: "Markus H.", city: "Bremen",   car: "BMW 320d",        amount: 1325, ago: "8 Min" },
  { name: "Sandra L.", city: "Hamburg",  car: "Audi A4 Avant",   amount: 1840, ago: "23 Min" },
  { name: "Daniel P.", city: "München",  car: "Mercedes GLC",    amount:  980, ago: "1 Std" },
  { name: "Julia K.",  city: "Bremen",   car: "VW Tiguan",       amount: 1450, ago: "2 Std" },
  { name: "Stefan R.", city: "Hannover", car: "BMW X3",          amount: 2210, ago: "3 Std" },
  { name: "Anna M.",   city: "Oldenburg",car: "Audi Q5",         amount: 1670, ago: "5 Std" },
  { name: "Tobias W.", city: "Bremen",   car: "Mercedes C-Klasse", amount: 1180, ago: "7 Std" },
  { name: "Lisa F.",   city: "Bremerhaven", car: "VW Passat",    amount:  890, ago: "Gestern" },
];

// Schadens-Konfigurator — Zonen mit Basis-Preisen (was Leasinggeber typischerweise berechnet)
export const DAMAGE_ZONES = [
  { id: "front-bumper",  label: "Frontstoßstange",   basePrice: 280 },
  { id: "hood",          label: "Motorhaube",         basePrice: 420 },
  { id: "fender-front",  label: "Kotflügel vorne",    basePrice: 220 },
  { id: "door-front",    label: "Tür vorne",          basePrice: 280 },
  { id: "door-rear",     label: "Tür hinten",         basePrice: 280 },
  { id: "side-panel",    label: "Seitenteil hinten",  basePrice: 350 },
  { id: "rear",          label: "Heck / Kofferraum",  basePrice: 380 },
  { id: "rear-bumper",   label: "Heckstoßstange",     basePrice: 280 },
  { id: "wheels",        label: "Felgen (alle 4)",    basePrice: 480 },
  { id: "interior",      label: "Innenraum",          basePrice: 380 },
  { id: "roof",          label: "Dach",               basePrice: 520 },
  { id: "mirror",        label: "Spiegel",            basePrice: 180 },
];

export const SEVERITY = {
  leicht: { label: "Leicht", multiplier: 1.0,  color: "#FFB400" },
  mittel: { label: "Mittel", multiplier: 1.9,  color: "#FB923C" },
  stark:  { label: "Stark",  multiplier: 2.8,  color: "#EF4444" },
};

// 5 Leistungsbereiche — Fokus Leasingrückläufer
export const SERVICES = [
  {
    id: "leasing",
    badge: "Kernleistung",
    title: "Leasingrückgabe Service",
    desc:
      "Wir machen Ihr Fahrzeug rückgabe-fertig – damit Sie keine teuren Nachzahlungen riskieren.",
    bullets: [
      "Vorbereitung auf die Leasingrückgabe",
      "Leasing-Rückgabe-Check",
      "Schadensbewertung vor Rückgabe",
      "Vermeidung hoher Nachzahlungen",
      "Komplette Rückgabevorbereitung",
      "Unterstützung bei Leasingrückgaben",
    ],
    featured: true,
  },
  {
    id: "innenraum",
    badge: "Aufbereitung",
    title: "Innenraum-Aufbereitung",
    desc:
      "Ihr Innenraum wird wie neu – Polster, Leder, Himmel und Kunststoff. Inkl. Geruchsbeseitigung.",
    bullets: [
      "Innenraumreinigung & Tiefenreinigung",
      "Polsterreinigung & Lederpflege",
      "Himmel- & Kunststoffpflege",
      "Geruchsbeseitigung & Flecken",
      "Teppichreinigung",
    ],
  },
  {
    id: "aussen",
    badge: "Aufbereitung",
    title: "Außen-Aufbereitung",
    desc:
      "Vom Handwasch-Service bis zur Hochglanzpolitur mit Versiegelung – Ihr Lack zeigt sich von seiner besten Seite.",
    bullets: [
      "Handwäsche & Lackreinigung",
      "Lackaufbereitung & Hochglanzpolitur",
      "Maschinenpolitur",
      "Versiegelung",
      "Kratzeraufbereitung",
    ],
  },
  {
    id: "smart-repair",
    badge: "Reparatur",
    title: "Smart Repair / Spot Repair",
    desc:
      "Die günstige Alternative zur Lackierung: Wir beheben Kratzer und kleine Lackschäden punktgenau.",
    bullets: [
      "Smart Repair & Spot Repair",
      "Kratzerentfernung",
      "Lackkratzer ausschleifen & polieren",
      "Kleine Lackschäden beheben",
      "Günstige Alternative zur Lackierung",
    ],
  },
  {
    id: "karosserie",
    badge: "Reparatur",
    title: "Karosserie & Lack",
    desc:
      "Dellen raus, Lack drauf – auch kleine Unfallschäden sind kein Problem.",
    bullets: [
      "Dellenentfernung & Ausbeularbeiten",
      "Lackierungen & Teil-Lackierungen",
      "Stoßstangen­reparatur",
      "Kleine Unfallschäden beheben",
    ],
  },
  {
    id: "premium",
    badge: "Service",
    title: "Premium Service",
    desc:
      "Alles aus einer Hand: Wir holen Ihr Auto ab, bereiten es auf und geben es für Sie zurück.",
    bullets: [
      "Hol- & Bringdienst",
      "Fahrzeugabholung von Zuhause",
      "Fahrzeugrückgabe beim Leasinggeber",
      "Komplette Organisation der Rückgabe",
      "Persönliche Beratung",
    ],
  },
];

export const BENEFITS = [
  "Nachzahlungen vermeiden",
  "Hunderte bis tausende Euro sparen",
  "Weniger Stress bei der Rückgabe",
  "Fahrzeug optisch deutlich aufwerten",
  "Professioneller Eindruck beim Leasinggeber",
  "Alles aus einer Hand",
];

export const FAQS = [
  {
    q: "Wann sollte ich AutoCoach vor der Leasingrückgabe ansprechen?",
    a: "Am besten 4–6 Wochen vor dem Rückgabetermin. So bleibt genug Zeit für Vorab-Check, Smart Repair und Aufbereitung – und der Termin verläuft entspannt.",
  },
  {
    q: "Wie viel kann ich konkret sparen?",
    a: "Im Schnitt 600–1.800 € gegenüber den Nachzahlungen, die Leasinggeber für Lackkratzer, Dellen und Innenraum-Schäden in Rechnung stellen. Mit unserem 60-Sekunden-Spar-Check oben sehen Sie Ihre persönliche Ersparnis sofort.",
  },
  {
    q: "Was kostet eine Beratung bei AutoCoach?",
    a: "Das Erstgespräch und der Spar-Check sind komplett kostenlos und unverbindlich. Danach bekommen Sie ein transparentes Festpreis-Angebot – Sie entscheiden frei.",
  },
  {
    q: "Lohnt sich Smart Repair gegenüber einer richtigen Lackierung?",
    a: "Bei Kratzern, Steinschlägen und kleinen Lackschäden fast immer ja. Smart Repair kostet einen Bruchteil einer Lackierung, ist meist in wenigen Stunden fertig – und der Leasinggeber akzeptiert das Ergebnis.",
  },
  {
    q: "Holen Sie das Fahrzeug bei mir ab?",
    a: "Ja. Unser Premium Service umfasst Hol- & Bringdienst und – auf Wunsch – auch die komplette Rückgabe beim Leasinggeber. Sie müssen sich um nichts kümmern.",
  },
  {
    q: "Sind Sie ein Autohaus?",
    a: "Nein – und genau das ist der Unterschied. AutoCoach ist unabhängig. Wir arbeiten ausschließlich in Ihrem Interesse und nicht für eine Händler-Provision.",
  },
];

export const TESTIMONIALS = [
  {
    name: "Markus H.",
    role: "Leasingrückgabe BMW 320d",
    rating: 5,
    text:
      "Der Leasinggeber wollte mir 1.800 € für Kratzer und kleine Dellen aufdrücken. AutoCoach hat alles vor der Rückgabe behoben – am Ende habe ich 1.400 € gespart. Beste Investition.",
  },
  {
    name: "Sandra L.",
    role: "Komplettaufbereitung Audi A4",
    rating: 5,
    text:
      "Innenraum wie neu, Lack spiegelglatt – und das alles direkt vor meiner Tür abgeholt. Bei der Rückgabe gab es null Beanstandungen. Klare Empfehlung.",
  },
  {
    name: "Daniel P.",
    role: "Smart Repair Mercedes GLC",
    rating: 5,
    text:
      "Drei Lackkratzer, eine Delle – Werkstatt wollte über 1.200 €. AutoCoach hat alles für 380 € gemacht. Sieht aus wie nie passiert.",
  },
];

export const PROCESS_STEPS = [
  {
    step: "01",
    title: "60-Sekunden Spar-Check",
    desc: "Beantworten Sie 4 kurze Fragen – Sie sehen sofort, wieviel Sie bei der Rückgabe sparen können.",
  },
  {
    step: "02",
    title: "Kostenlose Beratung per WhatsApp",
    desc: "Wir besprechen Ihren Fall, prüfen Fotos Ihres Fahrzeugs und nennen Ihnen einen Festpreis.",
  },
  {
    step: "03",
    title: "Wir machen den Rest",
    desc: "Abholung, Aufbereitung, Smart Repair – auf Wunsch bis zur Rückgabe beim Leasinggeber.",
  },
];

// Helper: build WhatsApp link with prefilled message
export const buildWhatsAppLink = (message = "Hallo AutoCoach, ich interessiere mich für Ihre Leasingrückgabe-Beratung.") => {
  return `https://wa.me/${COMPANY.whatsappNumber}?text=${encodeURIComponent(message)}`;
};
